import { z } from 'zod';

export const checkInFormSchema = z.object({
  newValue: z
    .number({
      required_error: 'Novo valor é obrigatório',
      invalid_type_error: 'Novo valor deve ser um número',
    })
    .min(0, 'Valor deve ser maior ou igual a zero'),
  impediments: z.string().optional(),
  notes: z.string().optional(),
  actionsRequired: z.string().optional(),
});

export type CheckInFormSchema = z.infer<typeof checkInFormSchema>;

export const FORM_FIELD_CLASSES = {
  label: 'block text-sm font-medium text-gray-700 font-montserrat mb-1',
  input:
    'block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm font-montserrat text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500',
  textarea:
    'block w-full rounded-lg border border-gray-300 px-3 py-2 text-sm font-montserrat text-gray-900 placeholder-gray-400 focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 resize-none',
  error: 'mt-1 text-sm text-red-600 font-montserrat',
  button:
    'px-4 py-2 rounded-lg font-medium font-montserrat text-sm transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-offset-2',
  buttonPrimary:
    'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
  buttonSecondary:
    'bg-gray-100 text-gray-700 hover:bg-gray-200 focus:ring-gray-500',
};
